<div class="modal-header" mat-dialog-title>
  <div class="modal-header-icon"><mat-icon class="material-symbols-outlined">link_off</mat-icon></div>
  <div class="modal-header-titles">
    <h2 class="modal-title">Desvincular da oportunidade</h2>
    <span class="modal-subtitle">{{ subtitulo }}</span>
  </div>
  <div class="modal-header-close-btn-container">
    <button mat-icon-button type="button" class="modal-close-btn icon-mat-symbols-btn" [disabled]="isDesvinculando"
      (click)="fechar()" matTooltip="Fechar" aria-label="Fechar">
      <mat-icon class="material-symbols-outlined">close</mat-icon>
    </button>
  </div>
</div>

<mat-dialog-content class="modal-content">
  <p class="dod-pergunta">
    Desvincular este documento da {{ textoOportunidade }}? {{ textoSemAlteracao }}
  </p>
</mat-dialog-content>

<mat-dialog-actions class="modal-footer">
  <button mat-stroked-button type="button" class="btn-secondary" [disabled]="isDesvinculando" (click)="fechar()">
    Cancelar
  </button>
  <button mat-flat-button type="button" class="btn-primary btn-spinner" [class.btn-loading]="isDesvinculando"
    [disabled]="isDesvinculando" [attr.aria-label]="isDesvinculando ? 'Desvinculando' : 'Desvincular'"
    (click)="desvincular()">
    <mat-icon class="material-symbols-outlined">link_off</mat-icon>
    Desvincular
    @if (isDesvinculando) { <mat-spinner diameter="20"></mat-spinner> }
  </button>
</mat-dialog-actions>
